import React, { Fragment, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import AddendumFullReport from "../../Layout/PDF/AddendumFullReport";
import GapAssessmentsFullReport from "../../Layout/PDF/GapAssessmentsFullReport";
import FullScopeFullReport from "../../Layout/PDF/FullScopeFullReport";
import AddendumSummary from "../../Layout/PDF/AddendumSummary";
import GapAssessmentsSummaryReport from "../../Layout/PDF/GapAssessmentsSummary";
import FullScopeSummaryReport from "../../Layout/PDF/FullScopeSummary";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import ReportDownload from "../AuditPDF/Report/ReportDownloadPDF";
import SummaryDownload from "../AuditPDF/Summary/SummaryDownload";
export default function Download({row}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  //  console.log(row.form_id)
  //  console.log({...row})

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const getCertifications = async (formId) => {
  //   try {
  //     const token = await getToken();
  
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_SERVER_URL}/download-certificate/${formId}`,
  //       {
  //         headers: {
  //           'oidc-token': token,
  //         },
  //         responseType: 'blob', // 🔥 This is the fix
  //       }
  //     );
  
  //     // Create blob and download
  //     const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `${formId}.pdf`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  
  //     console.log('Certificate downloaded');
  //   } catch (error) {
  //     console.error('Failed to download certificate:', error);
  //     alert('Download failed.');
  //   }
  // };
  

  // useEffect(() => {
  //   getCertifications()
  // }, []);

  const unitID = row.uiut.match(/^\d+/)[0];
  const year = row.form_id.match(/^\d{4}/)[0];

  // console.log(year); // "2025"
  // console.log(unitID); // "115"

  const getCertifications = async (formId, version) => {
    try {
      const token = await getToken();
      const payload = {
        form_id: formId
      }
      
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/certificate/download-certificate`,payload,
        {
          headers: {
            'oidc-token': token,
            'Content-Type': 'application/json',
          },
          responseType: 'blob', // Important to handle PDF response
        }
      );
  
      // Create blob and trigger download
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${year}_${unitID}_QMS Certificate.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoading(false);
        console.log('Certificate downloaded');
      }

      
    } catch (error) {
      setLoading(false);
      console.error('Failed to download certificate:', error);
      alert('Download failed.');
    }
  };
  

  return (
    <Fragment>
      <div onClick={handleClickOpen}>
        <Button
          style={{
            backgroundColor: `#d8e5ad`,
            border: "none",
            color: "#41530b",
            textTransform: "capitalize",
          }}
        >
          Download
        </Button>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="download-dialog"
      >
        <DialogTitle id="alert-dialog-title">
        
        <div style={{display:"flex",justifyContent:"space-between",alignContent:"center",alignItems:"center"}}>
          <div style={{display:"grid"}}>
            <span>{`Report for  Audit Number ${row.form_id}`}</span>
            <span style={{ paddingBottom: "10px", display: "block",fontSize:"14px" }}>
                Download report for {row.protocol_type}
              </span>
          </div>
          {row.certicate_status === 1 && (
            <button className="text-red-500 font-bold py-2 px-4 rounded  border-red-700 hover:bg-red-500 hover:text-white"
            style={{fontSize:"14px",paddingLeft:"10px",border:"1px solid"}} onClick={() => getCertifications(row.form_id,row.version)}>{loading ? 'Downloading...' : 'Download Certificate'}</button>
           )}

        </div>
       

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          


            <div style={{ display: "flex", gap: "10px", justifyContent:"space-between"}}>
              <>
                <>
                    <ReportDownload
                      formid={row.form_id}
                      type={row.protocol_type}
                      version={row.version ? row.version : row?.row?.version}
                    />

                  {/* {row.protocol_type === "Addendum" ? (
                    <AddendumFullReport
                      formid={row.form_id}
                      type={row.protocol_type}
                      version={row.version ? row.version : row?.row?.version}
                    />
                   
                  ) : row.protocol_type === "Gap Assessment" ? (
                    <GapAssessmentsFullReport
                      formid={row.form_id}
                      type={row.protocol_type}
                      version={row.version ? row.version : row?.row?.version}
                    />
                  ) : row.protocol_type === "Full Scope" ? (
                    <FullScopeFullReport
                      formid={row.form_id}
                      type={row.protocol_type}
                      version={row.version ? row.version : row?.row?.version}
                    />
                  ) : (
                    <></>
                  )} */}
                </>
              </>
              <>
              <SummaryDownload
                    formid={row.form_id}
                    type={row.protocol_type}
                    version={row.version ? row.version : row?.row?.version}
                  />
                {/* {row.protocol_type === "Addendum" ? (
                  <AddendumSummary
                    formid={row.form_id}
                    type={row.protocol_type}
                    version={row.version ? row.version : row?.row?.version}
                  />
                  
                  
                   
                ) : row.protocol_type === "Gap Assessment" ? (
                  <GapAssessmentsSummaryReport
                    formid={row.form_id}
                    type={row.protocol_type}
                    version={row.version ? row.version : row?.row?.version}
                  />
                ) : row.protocol_type === "Full Scope" ? (
                  <FullScopeSummaryReport
                    formid={row.form_id}
                    type={row.protocol_type}
                    version={row.version ? row.version : row?.row?.version}
                  /> */}
                {/* ) : (
                  <></>
                )} */}
              </>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
